/**
 * @fileoverview This is a temporary abstraction of API services that shouldn't be added to. This
 * is meant as a quick stop-gap to make it easier to refactor later.
 *
 * TODO: Decompose into separate files for each request.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Api } from '../../types/enums/api.enum';
import { ComplianceSettingsUtils } from '../../utils/compliance-settings';
import { ConsumerIdentityUtils } from '../../utils/consumer-identity/consumer-identity';
import { HttpHeader } from '../../types/enums/http-header.enum';
import { axiosService } from '../axios.service';
export class ApiService {
    /**
     * Auth provider `/accountholder/authentications/lookup`
     */
    static authProviderLookup({ accountReference, authenticatePayload, authenticationContext, cardToken, idToken, idLookupSessionId }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (accountReference.consumerIdentity &&
                !ConsumerIdentityUtils.isVersionOne(accountReference.consumerIdentity)) {
                throw new Error('Invalid consumer identity provided.');
            }
            return yield axiosService.post(Api.AUTH_PROVIDER_LOOKUP, {
                accountReference,
                authenticationContext,
                serviceId: authenticatePayload.serviceId,
                srcClientId: authenticatePayload.srcClientId,
                srcCorrelationId: authenticatePayload.srcCorrelationId,
                srciTransactionId: authenticatePayload.srciTransactionId
            }, {
                headers: getLookupHeaders()
            });
            function getLookupHeaders() {
                /**
                 * Currently a stop-gap for backend using the same header for both.
                 * "Theoretically" we'll never get both at the same time.
                 *
                 * TODO: Split into two headers once backend supports it.
                 */
                const lookupOrSessionToken = idLookupSessionId || authenticatePayload.sessionToken;
                return Object.assign(Object.assign(Object.assign(Object.assign({}, (cardToken && { [HttpHeader.X_SRC_CARD_TOKEN]: cardToken })), (idToken && { [HttpHeader.X_SRC_MCID_TOKEN]: idToken })), (lookupOrSessionToken && { [HttpHeader.X_SRC_SESSION_TOKEN]: lookupOrSessionToken })), { [HttpHeader.X_SRC_CX_FLOW_ID]: authenticatePayload.traceId });
            }
        });
    }
    /**
     * Precheckout `/identities/validation`
     */
    static precheckoutIdentitiesValidation({ appInstance, authenticatePayload, complianceSettings, idVerificationId, nudetectWidgetData, validationData }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield axiosService.post(Api.PRECHECKOUT_IDENTITY_VALIDATION, Object.assign(Object.assign(Object.assign({}, (appInstance && { appInstance })), (complianceSettings && {
                complianceSettings: ComplianceSettingsUtils.transformToVersionPointNine(complianceSettings)
            })), { idVerificationId,
                validationData }), {
                headers: Object.assign(Object.assign({}, (nudetectWidgetData && {
                    [HttpHeader.X_SRC_NUDETECT_WIDGET_DATA]: nudetectWidgetData
                })), { [HttpHeader.SRCI_TRANSACTION_ID]: authenticatePayload.srciTransactionId, [HttpHeader.SRC_CLIENT_ID]: authenticatePayload.srcClientId, [HttpHeader.SRC_CORRELATION_ID]: authenticatePayload.srcCorrelationId, [HttpHeader.SRC_DSA_ID]: authenticatePayload.srcDpaId, [HttpHeader.SRC_RECIPIENT_KEY_ID]: authenticatePayload.srcClientId, [HttpHeader.X_SRC_CX_FLOW_ID]: authenticatePayload.traceId, [HttpHeader.X_SRC_TRACE_ID]: authenticatePayload.traceId })
            });
        });
    }
    /**
     * Precheckout `/identities/verification`
     */
    static precheckoutIdentitiesVerification({ accountReference, authenticatePayload, idLookupSessionId, nudetectWidgetData, requestedValidationChannel }) {
        return __awaiter(this, void 0, void 0, function* () {
            const consumerIdentity = ConsumerIdentityUtils.transformToVersionPointNine(accountReference.consumerIdentity);
            if (!consumerIdentity) {
                throw new Error('Invalid consumer identity provided.');
            }
            return yield axiosService.post(Api.PRECHECKOUT_IDENTITY_VERIFICATION, {
                consumerIdentity,
                idLookupSessionId,
                requestedValidationChannel
            }, {
                headers: Object.assign(Object.assign({}, (nudetectWidgetData && {
                    [HttpHeader.X_SRC_NUDETECT_WIDGET_DATA]: nudetectWidgetData
                })), { [HttpHeader.SRCI_TRANSACTION_ID]: authenticatePayload.srciTransactionId, [HttpHeader.SRC_CLIENT_ID]: authenticatePayload.srcClientId, [HttpHeader.SRC_CORRELATION_ID]: authenticatePayload.srcCorrelationId, [HttpHeader.SRC_DSA_ID]: authenticatePayload.srcDpaId, [HttpHeader.SRC_RECIPIENT_KEY_ID]: authenticatePayload.srcClientId, [HttpHeader.X_SRC_CX_FLOW_ID]: authenticatePayload.traceId, [HttpHeader.X_SRC_TRACE_ID]: authenticatePayload.traceId })
            });
        });
    }
}
